/**
 * Generates an integer hash based on the given string contents.
 *   Guaranteed to always return the same hash for the same string at all times.
 *
 * Source: djb2 hash algorithm: http://www.cse.yorku.ca/~oz/hash.html
 *
 * @param {string} s
 * @returns {number}
 */
export function stableHashForString(s) {
  let hash = 0, i, chr;
  for (i = 0; i < s.length; i++) {
    chr = s.charCodeAt(i);
    hash = ((hash << 5) - hash) + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
}
